import {Component, ViewChild} from '@angular/core';
import {MatSidenav} from '@angular/material/sidenav';
import {Account} from "./domain/models";
import {OpenbandService} from "./services/openband/openband.service";
import {PreferencesService} from "./services/preferences/preferences.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styles: []
})
export class AppComponent {
  title = 'Expo - Кросс Наций';
  @ViewChild('sidenav') sidenav: MatSidenav;
  isExpanded = true;
  showSubmenu: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;
  account: Account = new Account();

  constructor(
    private api: OpenbandService,
    private preferences: PreferencesService,
  ) {
    this.loadAccount()
  }

  mouseenter() {
    if (!this.isExpanded) {
      this.isShowing = true;
    }
  }

  mouseleave() {
    if (!this.isExpanded) {
      this.isShowing = false;
    }
  }

  loadAccount() {
    try {
      this.api.getAccountSettings().subscribe(
        res => {
          this.account = res
          var old = this.preferences.appPreferences
          if (old?.sessions == null) old.sessions = []
          let found = old?.sessions?.find(x => x.token == this.preferences.appPreferences.token)
          let indexOf = old?.sessions?.indexOf(found)
          old.sessions[indexOf].userData = res
          this.preferences.setAppPreferences(old)
        }
      )
    } catch (e) {

    }
  }
}
